<template>
    <CustomTopSheetDialog v-model="show" :width="600" :title="null" :customclass="'px-4 pt-4'">
        <template #title>
            <h3 class="text-left dialog-title" color="primary">
                {{ $t('global.menu.account.avatar.shop.title') }}
            </h3>
        </template>

        <template #default>
            <p>
                {{ $t('global.menu.account.avatar.shop.hint') }}
            </p>
            <p v-html="$t('global.menu.account.avatar.shop.guide')">
            </p>
            <v-row justify="center" class="py-4">
                <cropper :aspectRatio="1 / 1" ref="cropper" class="cropper mb-2" :src="selectedImage.src"
                    v-if="selectedImage.src && image == null" :stencil-props="{
                        aspectRatio: 1 / 1,
                        movable: true,
                        resizable: true
                    }" />
                <v-img v-else-if="image != null" :aspectRatio="1 / 1" contain class="mb-2" height="256px" width="256px"
                    :src="image"></v-img>
                <v-sheet v-else color="#cacaca" height="256px" width="256px"
                    class="d-flex justify-content-center align-items-center">
                    <v-hover>
                        <template v-slot:default="{ isHovering, props }">
                            <v-btn @click="triggerFileSelect" v-bind="props" color="white" size="large"
                                :variant="isHovering ? 'flat' : 'outlined'" rounded="xl">{{ $t('entity.action.chooseAvatarImage.shop') }}</v-btn>
                        </template>
                    </v-hover>
                </v-sheet>
                <!-- Hidden file input -->
                <input type="file" accept="image/*" ref="fileInput" style="display: none;" @change="handleFileChange" />
            </v-row>
            <v-btn class="mx-auto d-block" size="large" variant="flat" color="primary" rounded="xl" @click="cropImage"
                v-if="selectedImage.src">Zuschneiden</v-btn>
        </template>

        <template #actions>
            <v-container class="d-flex align-items-center justify-content-end">
                <v-btn class="px-3 py-1 mr-3" variant="flat" rounded="xl" size="large" prepend-icon="mdi-cancel"
                    color="default" @click="closeSheet">{{ $t('entity.action.cancel') }}</v-btn>
                <v-btn @click="saveLogo" :disabled="!saveableLogo" class="px-3 py-1" variant="flat" rounded="xl" size="large"
                    prepend-icon="mdi-content-save" color="primary">{{ $t('entity.action.save') }}</v-btn>
            </v-container>
        </template>
    </CustomTopSheetDialog>
</template>


<script>
import { CircleStencil, Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
export default {
    name: "EditShopLogoDialog",
    components: {
        Cropper, CircleStencil
    },
    // props: {
    //     modelValue: {
    //         type: Boolean,
    //         required: true,
    //     },
    // },
    // computed: {
    //     show: {
    //         get() {
    //             return this.modelValue;
    //         },
    //         set(value) {
    //             this.$emit("update:modelValue", value);
    //         },
    //     },
    // },
    methods: {
        getCroppedData() {
            const { coordinates, canvas, } = this.$refs.cropper.getResult();
            return { coordinates, canvas, }
        }
    },
};
</script>
<script setup>
import { ref, defineModel, getCurrentInstance, inject } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';

const hardToken = localStorage.getItem("hardToken");
const username = localStorage.getItem("username");
const softToken = localStorage.getItem("softToken");
const show = defineModel();
const image = ref(null);
const { proxy } = getCurrentInstance();

const closeSheet = () => {
    show.value = false;
    image.value = null;
    saveableLogo.value = null;
    saveableFile.value = null;
    resetImage();
};

const fileInput = ref(null);

const selectedImage = ref({
    src: null,
    width: 80,
    height: 80,
    transforms: {
        rotate: 15,
        flip: {
            horizontal: true,
            vertical: false,
        },
    },
});
const saveableLogo = ref(null)
const cropImage = () => {
    saveableLogo.value = proxy.getCroppedData()
    image.value = saveableLogo.value.canvas.toDataURL();
    resetImage();
}

const triggerFileSelect = () => {
    // image.value = null;
    fileInput.value.click();
};
const saveableFile = ref(null);
const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
        saveableFile.value = file;
        const reader = new FileReader();
        reader.onload = (e) => {
            const tempimage = new Image();
            tempimage.onload = () => {
                selectedImage.value.src = e.target.result; // Set the base64 data URL
                // selectedImage.value.width = 'auto'; // Get the image width
                // selectedImage.value.height = 488; // Get the image height
            };
            tempimage.src = e.target.result;
        };
        reader.readAsDataURL(file);
    }

    fileInput.value.value = '';
};
const fetchOwnShop = inject('fetchOwnShop');

const convertToBlob = async (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onloadend = () => {
            const blob = new Blob([reader.result], { type: file.type });
            resolve(blob);
        };
        reader.onerror = (error) => reject(error);
    });
};

const saveLogo = async () => {

    if (!saveableFile.value) {
        console.error("No file selected.");
        return;
    }
    const logoObj = {
        file: saveableFile.value,
        x: saveableLogo.value.coordinates.left,
        y: saveableLogo.value.coordinates.top,
        height: saveableLogo.value.coordinates.height,
        width: saveableLogo.value.coordinates.width
    }
    try {
        const blobFile = await convertToBlob(saveableFile.value);

        const formData = new FormData();
        formData.append("file", blobFile);
        formData.append("x", logoObj.x);
        formData.append("y", logoObj.y);
        formData.append("height", logoObj.height);
        formData.append("width", logoObj.width);
        

        const response = await fetch(process.env.VUE_APP_API_BASE_URL + '/image/avatar', {
            method: "POST",
            body: formData, // Don't manually set headers
            headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
            },
        });

        if (response.data.status == 'OK') {
            closeSheet();
        }

    } catch (error) {
        console.error("Error uploading image:", error);
    } finally {
        closeSheet();
        fetchOwnShop();
        // loading.value = false;
    }
}

const resetImage = () => {
    selectedImage.value = {
        src: null,
        width: 80,
        height: 80,
        transforms: {
            rotate: 15,
            flip: {
                horizontal: true,
                vertical: false,
            },
        },
    }
}


</script>
